import React from 'react'
import styles from './wrapper.styles'
import injectSheet from 'react-jss'
import Categories from '../categories/categories.container'
import Groups from '../groups/groups.container'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const GroupsSelection = ({ classes, className }) => (
  <div className={classNames(classes.wrapper, className)}>
    <Categories className={classes.categories} />
    <Groups className={classes.groups} />
  </div>
)

GroupsSelection.propTypes = {
  /** Additional className for restyling purposes */
  className: PropTypes.string
}

export default injectSheet(styles)(GroupsSelection)
